import { i18n } from './i18n';

export const useTranslation = (): { t: typeof i18n.t } => {
  return { t: i18n.t };
};
